// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","divider":"b2b-divider_divider__QZ2GZ"};